import type { BillingCountedTask, CreateBillingCountedTask } from '../billing/billing.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class BillingCountedTaskFactory extends ObjectFactory<BillingCountedTask> {
  protected getDefaults(): BillingCountedTask {
    return {
      ...baseDocumentFactory.build(),
      completedAt: new Date('2026-09-15T08:00:00.000Z'),
      countedAt: new Date('2026-09-15T10:00:00.000Z'),
      month: 9,
      taskId: 'aabbccddeeff001122334455',
      year: 2026,
    };
  }

  buildCreate(overrides: Partial<CreateBillingCountedTask> = {}): CreateBillingCountedTask {
    const { completedAt, countedAt, month, taskId, year } = this.build(overrides);
    return { completedAt, countedAt, month, taskId, year };
  }
}

export const billingCountedTaskFactory = new BillingCountedTaskFactory();
